import * as Api from 'src/api'
import { useAdminAccess } from 'src/helpers/hooks'
import { useTranslatable } from 'src/hooks/locale/utils'
import Checkbox from 'src/views/components/forms/formik/Checkbox'
import FileInput from 'src/views/components/forms/formik/FileInput'
import { FormError } from 'src/views/components/forms/formik/FormError'
import { FormSubmit } from 'src/views/components/forms/formik/FormSubmit'
import TextInput from 'src/views/components/forms/formik/TextInput'
import FormikTinyMce from 'src/views/components/forms/FormikTinyMce'
import { FormSection } from '../../../programs/AdministratorProgramPage/FormSection'

export function CourseSyllabusFormSection({
  hideSubmit = false,
  showFormError = true,
}: {
  readonly hideSubmit?: boolean
  readonly showFormError?: boolean
} = {}): JSX.Element {
  const t = useTranslatable()
  const canManageCourses = useAdminAccess().canManage('courses')

  return (
    <fieldset disabled={!canManageCourses} className="mt-4 min-w-0 rounded-card bg-card px-6 py-8">
      {showFormError ? <FormError /> : null}

      <FormSection title={t('syllabus:syllabus')}>
        <TextInput name="duration" type="text" label={t(['კურსის ხანგრძლივობა', 'Course Duration'])} />
        <FormikTinyMce name="hours" label={t(['საათები', 'Hours'])} />
        <FormikTinyMce name="lecturers" label={t(['ლექტორები', 'Lecturers'])} />
        <FormikTinyMce name="prerequisites" label={t(['წინაპირობები', 'Prerequisites'])} />
        <FormikTinyMce name="methods" label={t(['სწავლების მეთოდები', 'Teaching Methods'])} />
        <FormikTinyMce name="mission" label={t(['კურსის მიზანი', 'Course Mission'])} />
        <FormikTinyMce name="topics" label={t(['ძირითადი თემები', 'Major Topics'])} />
        <FormikTinyMce name="outcomes" label={t(['სწავლის შედეგები', 'Learning Outcomes'])} />
        <FormikTinyMce name="evaluation" label={t(['შეფასება', 'Evaluation'])} />
        <FormikTinyMce name="resources" label={t(['ძირითადი ლიტერატურა', 'Main Resources'])} />
        <FormikTinyMce
          name="otherResources"
          label={t(['დამატებითი ლიტერატურა და სხვა რესურსები', 'Additional Resources and Other Materials'])}
        />
        <FormikTinyMce name="schedule" label={t(['თემატიკა კვირების მიხედვით', 'Weekly Schedule'])} />

        <p className="mb-3 mt-4 font-bold text-primaryTextColor">
          {t(['კურსის მიერ განვითარებული კომპეტენციები', 'Competencies Developed by This Course'])}
        </p>
        <div className="mb-4 grid gap-3 sm:grid-cols-2">
          <Checkbox name="knowledge" label={t(['ცოდნა და გაცნობიერება', 'Knowledge and Awareness'])} />
          <Checkbox
            name="applying"
            label={t(['ცოდნის პრაქტიკაში გამოყენების უნარი', 'Ability to Practically Use Knowledge'])}
          />
          <Checkbox name="judgments" label={t(['დასკვნის გაკეთების უნარი', 'Conclusions'])} />
          <Checkbox name="communications" label={t(['კომუნიკაციის უნარები', 'Communication Skills'])} />
          <Checkbox name="learning" label={t(['სწავლის უნარი', 'Ability to Learn'])} />
          <Checkbox name="values" label={t(['ღირებულებები', 'Values'])} />
        </div>

        <FileInput
          name="syllabusFiles"
          config={Api.UploadConfigMap.default}
          label={t(['სილაბუსის ფაილი', 'Syllabus File'])}
          testId="syllabusFile"
        />
      </FormSection>

      {!hideSubmit && canManageCourses ? (
        <FormSubmit
          label={t('common:save')}
          classNames={{
            root: 'w-full flex justify-end border-t border-borderGrey py-4 mt-4',
            button: 'h-[48px]',
          }}
        />
      ) : null}
    </fieldset>
  )
}
